import classNames from 'classnames';
import React, { lazy, useState, useCallback, Suspense } from 'react';
import { ActionButtons, BUTTON_SIZE } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';

var css_248z = ".fE4FO{height:250px;width:209px}[dir] .fE4FO{margin:0}.fE4FO._156lI{height:330px;width:100%}[dir] .fE4FO._156lI{margin:0 auto}.hsrfn{height:1px;width:inherit}[dir] .hsrfn{background:var(--ricos-settings-dividers-color,rgba(51,51,51,.1));border:none;margin:12px 0}[dir] .kwzIM{margin:0 12px}[dir] .kwzIM._156lI{margin:5px 6px}";
var styles = {"colorPickerDialog":"fE4FO","mobile":"_156lI","colorPickerDialog_separator":"hsrfn","colorPickerDialog_buttons_wrapper":"kwzIM"};
styleInject(css_248z);

const CustomColorPicker = lazy(() => import('./CustomColorPicker.js'));
const CustomColorPickerDialog = ({
  t,
  initialColor,
  isMobile,
  onCancel,
  onChange,
  onSave
}) => {
  const [color, setColor] = useState(initialColor != null ? initialColor : "#000000");
  const onColorChange = useCallback(
    (newColor) => {
      setColor(newColor);
      onChange == null ? void 0 : onChange(newColor);
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement("div", { className: classNames(styles.colorPickerDialog, { [styles.mobile]: isMobile }) }, isMobile && /* @__PURE__ */ React.createElement(
    CustomColorPickerActionButtons,
    {
      isMobile,
      onCancel: () => onCancel(color),
      onSave: () => onSave(color),
      t
    }
  ), /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(CustomColorPicker, { color, onChange: onColorChange, t, isMobile })), !isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("hr", { className: styles.colorPickerDialog_separator }), /* @__PURE__ */ React.createElement(
    CustomColorPickerActionButtons,
    {
      isMobile,
      onCancel: () => onCancel(color),
      onSave: () => onSave(color),
      t
    }
  )));
};
const CustomColorPickerActionButtons = ({
  isMobile,
  onCancel,
  onSave,
  t
}) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.colorPickerDialog_buttons_wrapper, {
        [styles.mobile]: isMobile
      })
    },
    /* @__PURE__ */ React.createElement(
      ActionButtons,
      {
        size: BUTTON_SIZE.tiny,
        isMobile,
        onCancel: () => onCancel(),
        onSave: () => onSave(),
        t
      }
    )
  );
};

export { CustomColorPickerDialog as default };
//# sourceMappingURL=CustomColorPickerDialog.js.map
